module.exports = __webpack_public_path__ + "img/sign_out.2f119f12.svg";